import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-about',
  template: `
    <app-navigation-secondary-about></app-navigation-secondary-about>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryAboutComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/compat/compat-navigation-secondary-about.component.ts